<template>
  <div class="map-main">
    <div class="slot-div" v-if="!mapSlotFloat && !hideSlot">
      <slot>
        <Input placeholder="Search Address" :inputValue.sync="addressSearch" />
        <button @click="getMarkerFromAddress()">Search and Mark Location</button>
      </slot>
    </div>
    
    <div class="custom-map" :style="mapStyling">
      <transition name="slidein">
        <div class="message" v-if="message" :style="{ backgroundColor: message['background'] || 'white', color: message['color'] }">
          <div v-html="message['text']"></div>
          <div class="message-close" @click="clearMessage">x</div>
        </div>
      </transition>
      <div class="slot-float" v-if="mapSlotFloat && !hideSlot" :style="[ mainStyling, { top: mapFullScreen ? (isFullScreen ? '10px' : '60px') : '10px',
        left: mapFullScreen ? (isFullScreen ? '10px' : '50px') : '10px' } ]">
        <img v-if="mapSlotFloat" :src="require(`../assets/mapControlIcons/${mapOpenMenu ? 'menuclose' : 'menu'}.png`)" height="20" width="20" @click="openCloseMenu"
          :style="[ closeIconStyling, { zIndex: mapOpenMenu ? '' : '10', position: mapOpenMenu ? '' : 'absolute', width: mapOpenMenu ? '' : '100%',
          height: mapOpenMenu ? '' : '100%', padding: mapOpenMenu ? '' : '10px', backgroundColor: mapOpenMenu ? '' : 'white' } ]" />
        <slot :style="{ display: mapOpenMenu ? '' : 'none' }">
          <Input placeholder="Search Address" :inputValue.sync="addressSearch" />
          <button @click="getMarkerFromAddress()">Search and Mark Location</button>
        </slot>
      </div>
      <div ref="customMapv2" class="map"></div>
      <div class="zoom-buttons" :style="{ top: mapFullScreen ? (isFullScreen ? '10px' : '60px') : '10px' }">
        <Tooltip class="button" v-if="ViewMode" :showIndicator="false" position="left" style="cursor: default">
          <img style="pointer-events: none" src="../assets/mapControlIcons/disable.png" height="20" width="20" />
          <div slot="tooltipText">This map is in view mode.<br>You're not able to place a marker<br>or create any geofence on the map.</div>
        </Tooltip>
        <Tooltip class="button" v-if="maxMarkerCount != -1 && !ViewMode" :showIndicator="false" position="left" style="cursor: default">
          <!-- <img style="pointer-events: none" src="../assets/mapControlIcons/zoomout.png" height="20" width="20" /> -->
          {{ maxMarkerCount }}
          <div slot="tooltipText">Only {{ maxMarkerCount }} marker is allowed on the map<br><br>Placing an extra marker will remove<br>the first marker that you've placed.</div>
        </Tooltip>
        <Tooltip class="button" :showIndicator="false" position="left" tooltipText="Zoom Out" @click.native="zoomClicked('out')">
          <img style="pointer-events: none" src="../assets/mapControlIcons/zoomout.png" height="20" width="20" />
        </Tooltip>
        <Tooltip class="button" :showIndicator="false" position="left" tooltipText="Zoom In" @click.native="zoomClicked('in')">
          <img style="pointer-events: none" src="../assets/mapControlIcons/zoomin.png" height="20" width="20" />
        </Tooltip>
      </div>
      <div class="additional-buttons" :style="{ top: mapFullScreen ? (isFullScreen ? '10px' : '60px') : '10px' }">
        <Tooltip class="button" :showIndicator="false" position="left" :tooltipText="mapFullScreen ? 'Collapse' : 'Expand'" @click.native="mapFullScreen = !mapFullScreen">
          <img style="pointer-events: none" :src="require(`../assets/mapControlIcons/${mapFullScreen ? 'collapse' : 'expand'}.png`)" height="20" width="20" />
        </Tooltip>
        <Tooltip class="button" :showIndicator="false" position="left" tooltipText="Center My Location" @click.native="centerCurrentLocation">
          <img style="pointer-events: none" src="../assets/mapControlIcons/mylocation.png" height="20" width="20" />
        </Tooltip>
        <!-- <Tooltip v-if="mapMarkers.length > 0 && !ViewMode" class="button" :showIndicator="false" position="left" @click.native="clearMarker">
          <img style="pointer-events: none" src="../assets/mapControlIcons/clearmarker.png" height="20" width="20" />
          <div slot="tooltipText">Clear All Markers<br>Total of {{ mapMarkers.length }} marker{{ mapMarkers.length > 1 ? 's' : '' }}</div>
        </Tooltip>
        <Tooltip v-if="markerNotInView > 0" class="button" :showIndicator="false" position="left" @click.native="fitBounds">
          <img style="pointer-events: none" src="../assets/mapControlIcons/marker.png" height="20" width="20" />
          <div slot="tooltipText">Show all markers<br>Total of {{ markerNotInView }} marker{{ markerNotInView > 1 ? 's' : '' }} is not in view</div>
        </Tooltip> -->
        <Tooltip v-if="!geofenceIsVisible"  class="button" :showIndicator="false" position="left" @click.native="showGeofence">
          <img style="pointer-events: none" src="../assets/mapControlIcons/showgeofence.jpg" height="20" width="20" />
          <div slot="tooltipText">Show all existing geofence</div>
        </Tooltip>
        <Tooltip v-if="geofenceIsVisible" class="button" :showIndicator="false" position="left" @click.native="hideGeofence">
          <img style="pointer-events: none" src="../assets/mapControlIcons/hidegeofence.png" height="20" width="20" />
          <div slot="tooltipText">Hide all existing geofence</div>
        </Tooltip>
      </div>
      <div class="info-buttons" :style="{ zIndex: showHelp ? 12 : 10 }">
        <Tooltip class="button" :showIndicator="false" position="left" :tooltipText="showHelp ? 'Close Help' : 'Help'" @click.native="showHelp = !showHelp">
          <img style="pointer-events: none" :src="require(`../assets/mapControlIcons/${showHelp ? 'menuclose' : 'help'}.png`)" height="20" width="20" />
        </Tooltip>
      </div>
      <div class="map-type-button" :style="{ left: `${mapFullScreen ? 65 : 10}px` }">
        <Tooltip class="button" :showIndicator="false" position="top" :minWidth="200" @click.native="mapTypeClicked"
          :tooltipText="`Map Type\n(Current: ${currentMapType == 'roadmap' ? 'Default' : 'Satellite'} View)`">
          <img style="pointer-events: none" :src="require(`../assets/mapControlIcons/${currentMapType}Map.png`)" height="20" width="20" />
        </Tooltip>
      </div>
      <div class="map-help-container" v-if="showHelp">
        <div class="help-content">
          <Carousel :viewCount="4">
            <div slot="content1" class="carousel-content">
              <div class="title">Press anywhere on the map to add a marker.</div>
              <div class="image-gif-container">
                <img class="image-gif" src="../assets/mapControlIcons/mapGuide/marker.gif" alt="">
              </div>
            </div>
            <div slot="content2" class="carousel-content">
              <div class="title">Right click on the marker to view all the available options.</div>
              <div class="image-gif-container">
                <img class="image-gif" src="../assets/mapControlIcons/mapGuide/rightclick.gif" alt="">
              </div>
            </div>
            <div slot="content3" class="carousel-content">
              <div class="title">If available, there will be a menu on the top left of the map.<br>Click on it to use the available menu.</div>
              <div class="image-gif-container">
                <img class="image-gif" src="../assets/mapControlIcons/mapGuide/menu.gif" alt="">
              </div>
            </div>
            <div slot="content4" class="carousel-content">
              <div class="title">Hover on the available icons to know what it does.<br><br>If there is a limit on how many markers that you can place on the map, there will be an indicator on the left of the zoom out button.<br><br>If there is at least one marker on the map, a button will appear below the 'My Location' button to clear all the markers on the map.</div>
              <div class="image-gif-container">
                <img class="image-gif" src="../assets/mapControlIcons/mapGuide/hovering.gif" alt="">
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
    
    <div class="marker-context-menu" v-if="showContextMenu" :style="contextMenuPosition">
      <div class="context-menu-item" v-for="(c, i) in contextMenuItem" :key="i" @click="contextMenuClicked(c['text'])">{{ c['text'] }}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
    mainStyling: function() {
      return {
        maxWidth: this.mapOpenMenu ? '' : '40px',
        maxHeight: this.mapOpenMenu ? '250px' : '40px',
        minHeight: this.mapOpenMenu ? '' : '40px',
        overflow: this.mapOpenMenu ? 'auto' : 'hidden',
        display: this.mapOpenMenu ? '' : 'flex',
        alignItems: this.mapOpenMenu ? '' : 'center',
        justifyContent: this.mapOpenMenu ? '' : 'center'
      };
    },
    closeIconStyling: function() {
      return {
        left: this.mapOpenMenu ? '' : '0',
        top: this.mapOpenMenu ? '' : '0',
        position: this.mapOpenMenu ? '' : 'relative',
      };
    },
    mapStyling: function() {
      return {
        zIndex: this.mapFullScreen ? '999999999' : '',
        position: this.mapFullScreen ? 'fixed' : 'relative',
        top: this.mapFullScreen ? '0' : '',
        left: this.mapFullScreen ? '0' : '',
        width: this.mapFullScreen ? '100%' : '',
        height: this.mapFullScreen ? '100%' : '',
      }
    }
  },
  data: function() {
    return {
      map: null,
      mapFullScreen: false,
      availableMapTypes: ['roadmap', 'hybrid'],
      currentMapType: 'roadmap',

      mapCenter: { lat: 3.142831, lng: 101.679396 },
      mapZoom: 12,

      mapSlotFloat: true,
      mapOpenMenu: false,

      mapMarkers: [],
      fixedMapMarkers: [],
      tempMarker: null,
      tempMarkerTimeout: null,
      hideMarkers: false,
      markerNotInView: false,

      showHelp: false,

      showContextMenu: false,
      contextMenuPosition: {},
      contextMenuIndex: -1,
      fixedContextMenuIndex: -1,
      contextMenuItem: [],
      fixedContextMenuItem: [],
      markerCount: 0,
      message: null,
      messageTimeout: null,
      geofenceIsVisible: true,
      latInput: '',
      lngInput: '',

      mapBounds: [],
      isGeofence: false,

      addressSearch: '',
    }
  },
  props: {
    isFullScreen: { type: Boolean, default: false }, // If false, padding is 10px set trus if use within home page
    slotFloat: { type: Boolean, default: true }, // If false, the slot will be on the left of the map
    markers: { type: Array, default: function() { return [] } }, // All the markers and geofence (2wb)
    existingMarkers: { type: Array, default: function() { return [] } }, // All the markers and geofence (2wb)
    maxMarkerCount: { type: Number, default: -1 }, // -1 unlimited, 0 cannot add marker, > 0 can add n number of markers
    openMenu: { type: Boolean, default: false }, // Open to show the slot (2wb)
    ViewMode: { type: Boolean, default: false }, // Open to show the slot (2wb)
    geofenceViewMode: { type: Boolean, default: false }, // Open to show the slot (2wb)
    hideSlot: { type: Boolean, default: false }, // Do not show the menu

    // geofenceIsVisible: { type: Boolean, default: true }, 
    mapObject: { type: Object, default: function() { return null } },
    markerIcon: { type: String, default: '' },
    mapType: { type: String, default: 'roadmap' },
  },
  methods: {
    contextMenuClicked: function(item) {
      switch (item) {
        case 'Delete Marker':
          this.markerCount = 0;
          this.mapMarkers[this.contextMenuIndex]['marker'].setMap(null);
          if (this.mapMarkers[this.contextMenuIndex]['geofence']) {
            this.mapMarkers[this.contextMenuIndex]['geofence'].setMap(null);
          }
          this.mapMarkers.splice(this.contextMenuIndex, 1);
          this.updateExistingMarkerBinding();
          this.updateMarkerBinding();
          break;
        case 'Set Geofence':
          this.addGeofence(this.contextMenuIndex);
          this.addExistingGeofence(this.fixedContextMenuIndex);
          break;
        case 'Delete Geofence':
          this.mapMarkers[this.contextMenuIndex]['geofence'].setMap(null);
          this.mapMarkers[this.contextMenuIndex]['geofence'] = null;

          this.updateMarkerBinding();
          break;
        case 'Reset Geofence':
          this.mapMarkers[this.contextMenuIndex]['geofence'].setMap(null);
          this.mapMarkers[this.contextMenuIndex]['geofence'] = null;
          this.addGeofence(this.contextMenuIndex);
          break;
        case 'Hide Geofence':
          break;
     }

      this.showContextMenu = false;
      this.contextMenuIndex = -1;
      this.fixedContextMenuIndex = -1;
    },
    showMessage: function(text, background, color, timeout) {
      if (this.messageTimeout) {
        clearTimeout(this.messageTimeout);
        this.message = null;
      }

      this.$nextTick(() => {
        this.message = { text: text, background: background, color: color };
        this.messageTimeout = setTimeout(this.clearMessage, timeout || 3000);
      })
    },
    clearMessage: function() {
      this.message = null;
      if (this.messageTimeout) {
        clearTimeout(this.messageTimeout);
      }
    },
    updateMarkerBinding: function() {
      let markerBinding = this.mapMarkers.map(m => {
        let geofence = null;
        if (m['geofence']) {
          geofence = [];
          m.geofence.getPath().forEach(p => {
            geofence.push({ lat: p.lat(), lng: p.lng() });
          })
        }
        return {
          position: { lat: m['marker']['position'].lat(), lng: m['marker']['position'].lng() },
          geofence: geofence
        }
      });
      this.$emit('update:markers', markerBinding);
    },
    updateExistingMarkerBinding: function() {
      let existingMarkerBinding = this.fixedMapMarkers.map(m => {
        let geofence = null;
        if (m['geofence']) {
          geofence = [];
          m.geofence.getPath().forEach(p => {
            geofence.push({ lat: p.lat(), lng: p.lng() });
          })
        }
        return {
          position: { lat: m['marker']['position'].lat(), lng: m['marker']['position'].lng() },
          geofence: geofence
        }
      });
      this.$emit('update:existingMarkers', existingMarkerBinding);
    },
    openCloseMenu: function() {
      this.mapOpenMenu = !this.mapOpenMenu;
      this.$emit('update:openMenu', this.mapOpenMenu);
    },

    mapTypeClicked: function() {
      if (this.currentMapType == 'roadmap') {
        this.currentMapType = 'hybrid';
      } else {
        this.currentMapType = 'roadmap';
      }

      this.map.setMapTypeId(this.currentMapType);
    },

    //#region Public Methods
    getMap: function() {
      return this.map;
    },
    getMarkerFromAddress: async function(address) {
      let geocoder = new google.maps.Geocoder();
      try {
        let res = await geocoder.geocode({ address: address ? address : this.addressSearch });
        let resultLocation = res['results'][0]['geometry']['location'];
        let location = { lat: resultLocation.lat(), lng: resultLocation.lng() };
        this.addMarker(location);
        this.centerMap(location, 15);

        this.showMessage('Location found!<br>If location is not accurate, please enter a more precise address.', 'green', 'white', 5000);
      } catch (e) {
        if (e['code'] == 'ZERO_RESULTS') {
          this.showMessage(`No places found for ${address ? address : this.addressSearch}`, 'red', 'white');
        }
      }
    },
    // getAddressFromMarker: async function() {
    //   if (this.mapMarkers.length == 0) {
    //     this.showMessage('No marker found, please place a marker on the map first.', 'red', 'white');
    //     return;
    //   }

    //   if (this.fixedMapMarkers.length > 1) {
    //    let geocoder = new google.maps.Geocoder();
    //   try {
    //     this.fixedMapMarkers.forEach(function(obj){
    //     let res = await geocoder.geocode({ location: { lat: obj[0]['marker']['position'].lat(), lng: obj[0]['marker']['position'].lng() } });
    //     let resultLocation = res['results'].filter(r => r['types'].includes('street_address'));
    //     if (resultLocation.length == 0) {
    //       this.showMessage(`No address found for the placed marker. Please try with a different location OR enter the address manually.`, 'red', 'white');
    //       return null;
    //     } else {
    //       return resultLocation;
    //     }});
    //   } catch (e) {
    //     console.log(e);
    //     if (e['code'] == 'ZERO_RESULTS') {
    //       // this.showMessage(`No places found for ${address ? address : this.addressSearch}`, 'red', 'white');
    //     }

    //     return null;
    //   }
    //   }

    //   let geocoder = new google.maps.Geocoder();
    //   try {
    //     let res = await geocoder.geocode({ location: { lat: this.mapMarkers[0]['marker']['position'].lat(), lng: this.mapMarkers[0]['marker']['position'].lng() } });
    //     let resultLocation = res['results'].filter(r => r['types'].includes('street_address'));
    //     if (resultLocation.length == 0) {
    //       this.showMessage(`No address found for the placed marker. Please try with a different location OR enter the address manually.`, 'red', 'white');
    //       return null;
    //     } else {
    //       return resultLocation;
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     if (e['code'] == 'ZERO_RESULTS') {
    //       // this.showMessage(`No places found for ${address ? address : this.addressSearch}`, 'red', 'white');
    //     }

    //     return null;
    //   }
    // },
    placeMarker: function(marker, hide) {
      this.clearMarker();
      console.log("updateMarkerBinding");
      if (marker.length > 0) {
        marker.forEach(v => this.addMarker(v['position']));

        if (marker.length > 1) {
          this.fitBounds();
        } else {
          this.centerMap(this.mapMarkers[0]['marker'].getPosition(), 17);
        }
      } else {
        this.centerMap(this.mapCenter, 12);
      }

      if (hide) {
        this.mapMarkers.forEach(m => m['marker'].setVisible(false));
      }
    },
    placeFixedMarker: function(marker, hide) {
      this.clearMarker();
      if (marker.length > 0) {
        marker.forEach(v => this.addFixedMarker(v['position']));

        if (marker.length > 1) {
          this.fitBounds();
        } else {
          this.centerMap(this.fixedMapMarkers[0]['marker'].getPosition(), 17);
        }
      } else {
        this.centerMap(this.mapCenter, 12);
      }
      if(hide){
        this.fixedMapMarkers.forEach(m => m['marker'].setVisible(false));
      }
      
    },
    centerToMarker: function(pos) {
      this.centerMap(pos, 17);
    },
    addCustomMarker: function(marker) {
      marker.addListener('click', () => this.markerClicked(marker));
      marker.addListener('contextmenu', this.markerContextMenu);
      this.mapMarkers.push({ marker: marker, geofence: null });
    },
    fitBounds: function() {
      let markerBounds = new google.maps.LatLngBounds();
      if(this.mapMarkers.length == 0){
          this.fixedMapMarkers.forEach(m => {
            markerBounds.extend(m['marker']['position'])
            if (m['geofence']) {
                m['geofence'].getPath()['Rd'].forEach(p => {
                    markerBounds.extend({ lat: p.lat(), lng: p.lng() });
              })
            }
        });
      }
      else{
        this.mapMarkers.forEach(m => {
          markerBounds.extend(m['marker']['position'])
          if (m['geofence']) {
            m['geofence'].getPath()['Rd'].forEach(p => {
              markerBounds.extend({ lat: p.lat(), lng: p.lng() });
            })
          }
        });
      }
      this.map.fitBounds(markerBounds);
    },
    showGeofence: function() {
      if(!this.geofenceIsVisible){

        this.fixedMapMarkers.forEach(m => m['marker'].setVisible(true));
        this.fixedMapMarkers.forEach(m => m['geofence'].setVisible(true));
        this.geofenceIsVisible = true;
      }
    },
    hideGeofence: function() {
      if(this.geofenceIsVisible){
        this.fixedMapMarkers.forEach(m => m['marker'].setVisible(false));
        this.fixedMapMarkers.forEach(m => m['geofence'].setVisible(false));
        this.geofenceIsVisible = false;
      }
    },
    //#endregion
    
    //#region Geolocations
    centerCurrentLocation: function() {
      navigator.geolocation.getCurrentPosition(this.locationSuccess, this.locationError);
    },
    locationSuccess: function(e) {
      let pos = { lat: e['coords']['latitude'], lng: e['coords']['longitude'] };
      this.addTemporaryMarker(pos, 'bluedot.png', 40);
      this.centerMap(pos, 15);
    },
    locationError: function(e) {
      this.showMessage(e['message'], 'red', 'white');
    },
    //#endregion

    //#region Marker Functions
    addTemporaryMarker: function(pos, icon, size, timeout) {
      if (this.tempMarkerTimeout) {
        this.removeTempMarker();
        clearTimeout(this.tempMarkerTimeout);
      }

      let iconSize = size ? size : 25;
      this.$nextTick(() => {
        this.tempMarker = new google.maps.Marker({
          position: pos,
          map: this.map,
          icon: {
            url: require(`../assets/mapControlIcons/${icon ? icon : 'mylocation.png'}`),
            scaledSize: new google.maps.Size(iconSize, iconSize)
          }
        });

        this.tempMarkerTimeout = setTimeout(this.removeTempMarker, timeout ? timeout : 3000);
      })
    },
    removeTempMarker: function() {
      if (this.tempMarker) {
        this.tempMarker.setMap(null);
        this.tempMarker = null;
      }
    },
    addMarker: function(pos) {
      if(pos) this.markerCount = this.markerCount + 1 ;
      if (this.markerCount > 1) {
        this.mapMarkers[0]['marker'].setMap(null);
        if (this.mapMarkers[0]['geofence']) {
          this.mapMarkers[0]['geofence'].setMap(null);
        }
        this.mapMarkers.splice(0, 1);
      }

      let marker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: this.markerIcon ? {
          url: this.markerIcon,
          scaledSize: new google.maps.Size(40, 40)
        } : null,
      });
      marker.addListener('click', () => this.markerClicked(marker));
      marker.addListener('contextmenu', this.markerContextMenu);
      this.mapMarkers.push({ marker: marker, geofence: null });

      this.updateMarkerBinding();
    },
    addFixedMarker: function(pos) {
      if (this.fixedMapMarkers.length == this.maxMarkerCount) {
        this.fixedMapMarkers[0]['marker'].setMap(null);
        if (this.fixedMapMarkers[0]['geofence']) {
          this.fixedMapMarkers[0]['geofence'].setMap(null);
        }
        this.fixedMapMarkers.splice(0, 1);
      }

      let marker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: this.markerIcon ? {
          url: this.markerIcon,
          scaledSize: new google.maps.Size(40, 40)
        } : null,
      });
      marker.addListener('click', () => this.markerClicked(marker));
      marker.addListener('contextmenu', this.markerContextMenu);
      this.fixedMapMarkers.push({ marker: marker, geofence: null });

      this.updateExistingMarkerBinding();
    },
    clearMarker: function() {
      this.fixedMapMarkers.forEach(m => {
        m['marker'].setMap(null);
        if (m['geofence']) {
          m['geofence'].setMap(null);
        }
      });
      this.fixedMapMarkers = [];
      this.mapMarkers.forEach(m => {
        m['marker'].setMap(null);
        if (m['geofence']) {
          m['geofence'].setMap(null);
        }
      });
      this.mapMarkers = [];
      this.markerCount = 0;
      this.showContextMenu = false;
    },
    markerClicked: function(marker) {
      let pos = { lat: marker['position'].lat(), lng: marker['position'].lng() };
      this.centerMap(pos, 17);

      this.$emit('markerClicked', marker, pos);
    },
    markerContextMenu: function(e) {
      // if (this.ViewMode ) {
      //   this.showMessage('Right click on marker is not enabled on this map.', 'red', 'white');
      //   return;
      // }
      // if (this.geofenceViewMode) {
      //   this.showMessage('Right click on marker is not enabled on this geofence', 'red', 'white');
      //   return;
      // }

      let dom = e['domEvent'];
      this.showContextMenu = true;
      this.contextMenuPosition = {
        left: `${dom['x']}px`,
        top: `${dom['y']}px`,
        zIndex: this.mapFullScreen ? '1001' : '20'
      };

      let markersPosition = this.mapMarkers.map(m => `${m['marker']['position'].lat()},${m['marker']['position'].lng()}`);
      let fixedMarkersPosition = this.fixedMapMarkers.map(m => `${m['marker']['position'].lat()},${m['marker']['position'].lng()}`);
      let currentLatlng = `${e['latLng'].lat()},${e['latLng'].lng()}`;
      let currentCenter = { lat: e['latLng'].lat(), lng: e['latLng'].lng() };
      this.contextMenuIndex = markersPosition.indexOf(currentLatlng);
      this.fixedContextMenuIndex = fixedMarkersPosition.indexOf(currentLatlng);

      this.contextMenuItem = [];
      this.fixedContextMenuItem = [];
      if (this.mapMarkers[this.contextMenuIndex]['geofence']) {
        let defaultPath = this.getDefaultGeofence(currentCenter);
        let currentPath = this.mapMarkers[this.contextMenuIndex]['geofence'].getPath()['Kd'].map(p => {
          return {
            lat: p.lat(),
            lng: p.lng()
          }
        });

        if (JSON.stringify(defaultPath) != JSON.stringify(currentPath)) {
          this.contextMenuItem.push({ text: 'Reset Geofence' });
        }
      }
      this.contextMenuItem.push({ text: this.mapMarkers[this.contextMenuIndex]['geofence'] ? 'Delete Geofence' : 'Set Geofence' });
      
    },
    //#endregion

    //#region Geofence functions
    addGeofence: function(index) {
      let marker = this.mapMarkers[index];
      let center = { lat: marker['marker']['position'].lat(), lng: marker['marker']['position'].lng() };

      let geo = new google.maps.Polygon({
        paths: this.getDefaultGeofence(center),
        map: this.map,
        editable: !this.ViewMode,
        fillColor: '#1E97C1',
        fillOpacity: 0.3,
        strokeColor: '#1E97C1'
      });
      google.maps.event.addListener(geo.getPath(), 'insert_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'set_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'remove_at', () => this.geofenceChanged(geo, index));
      marker['geofence'] = geo;
      this.centerMap(center, 17);

      this.updateMarkerBinding();
    },
    addExistingGeofence: function(index) {

      let marker = this.fixedMapMarkers[index];
      let center = { lat: marker['marker']['position'].lat(), lng: marker['marker']['position'].lng() };
      let geo = new google.maps.Polygon({
        paths: this.getDefaultGeofence(center),
        map: this.map,
        editable: !this.geofenceViewMode,
        fillColor: '#CACED0',
        fillOpacity: 0.3,
        strokeColor: '#f9fdff',
        strokeOpacity : 0.8,
        strokeWeight : 2,
      });

      google.maps.event.addListener(geo.getPath(), 'insert_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'set_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'remove_at', () => this.geofenceChanged(geo, index));
      marker['geofence'] = geo;
      this.centerMap(center, 17);

      this.updateExistingMarkerBinding();
    },
    getDefaultGeofence: function(center) {
      let paths = [];
      let geoSize = 0.0005;
      paths.push({ lat: center['lat'] + geoSize, lng: center['lng'] - geoSize });
      paths.push({ lat: center['lat'] + geoSize, lng: center['lng'] + geoSize });
      paths.push({ lat: center['lat'] - geoSize, lng: center['lng'] + geoSize });
      paths.push({ lat: center['lat'] - geoSize, lng: center['lng'] - geoSize });

      return paths;
    },
    addGeofenceByPosition: function(index, paths) {
      let geo = new google.maps.Polygon({
        paths: paths,
        map: this.map,
        editable: !this.ViewMode,
        fillColor: '#1E97C1',
        fillOpacity: 0.3,
        strokeColor: '#1E97C1'
      });
      google.maps.event.addListener(geo.getPath(), 'insert_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'set_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'remove_at', () => this.geofenceChanged(geo, index));
      this.mapMarkers[index]['geofence'] = geo;

      this.updateMarkerBinding();
    },
    addFixedGeofenceByPosition: function(index, paths) {
      let geo = new google.maps.Polygon({
        paths: paths,
        map: this.map,
        editable: !this.geofenceViewMode,
        fillColor: '#707172',
        fillOpacity: 0.5,
        strokeColor: '#707172',
        strokeOpacity : 0.8,
        strokeWeight : 2,
      });
      google.maps.event.addListener(geo.getPath(), 'insert_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'set_at', () => this.geofenceChanged(geo, index));
      google.maps.event.addListener(geo.getPath(), 'remove_at', () => this.geofenceChanged(geo, index));
      this.fixedMapMarkers[index]['geofence'] = geo;

      this.updateExistingMarkerBinding();
    },
    geofenceChanged: async function(geofence, index) {
      this.mapMarkers[index]['geofence'] = geofence;

      //#region Get the lat lng bounds of the geofence
      let bounds = new google.maps.LatLngBounds();
      this.mapMarkers[index]['geofence'].getPath().getArray().forEach(p => bounds.extend(p));
      let geofenceCenter = bounds.getCenter();
      //#endregion

      let markerIsWithinPolygon = google.maps.geometry.poly.containsLocation(this.mapMarkers[index]['marker'].getPosition(), geofence);
      if (markerIsWithinPolygon) {
        this.updateMarkerBinding();
        return;
      }

      let count = 0;
      let loop = 0;
      let testPosition = geofenceCenter;
      let haveApproximate = true;
      do {
        if (++count >= 500) {
          haveApproximate = false;
          break;
        }
        // this.addMarker(testPosition);
        this.mapMarkers[index]['marker'].setPosition(testPosition);
        markerIsWithinPolygon = google.maps.geometry.poly.containsLocation(testPosition, geofence);

        if (!markerIsWithinPolygon) {
          let northWest = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getSouthWest().lng());
          let boundsHeightPerc = google.maps.geometry.spherical.computeDistanceBetween(northWest, bounds.getSouthWest()) / 100;
          let boundsWidthPerc = google.maps.geometry.spherical.computeDistanceBetween(northWest, bounds.getNorthEast()) / 100;
          testPosition = google.maps.geometry.spherical.computeOffset(geofenceCenter, loop % 2 == 0 ? (boundsHeightPerc * Math.ceil(count / 7)) : (boundsWidthPerc * Math.ceil(count / 7)), (loop * 45));
          loop++;
          if (loop > 7) {
            loop = 0;
          }
        }
        // await this.$sleep(100);
      } while (!markerIsWithinPolygon);
      
      if (haveApproximate) {
        this.showMessage('Your marker has been replaced since it was outside of your geofence.', 'yellow');
      } else {
        this.showMessage('Could not locate any center from your geofence, please edit your geofence and try again.', 'red', 'white');
      }

      this.updateMarkerBinding();
    },

    //#endregion

    //#region Map Events
    mapClicked: function(e) {
      if (this.ViewMode) {
        this.showMessage('Placing a marker is not enabled on this map.', 'red', 'white');
        return;
      }
      if(this.gefen)

      if (this.showContextMenu) {
        this.showContextMenu = false;
        return;
      }
      let latlng = e['latLng'];
      this.addMarker({ lat: latlng.lat(), lng: latlng.lng() });
    },
    zoomChanged: function() {
      this.showContextMenu = false;
      this.mapZoom = this.map.getZoom();
    },
    boundsChanged: function() {
      if (this.mapMarkers.length == 0) {
        return;
      }

      let count = 0;
      this.mapMarkers.forEach(m => {
        if (!this.map.getBounds().contains(m['marker'].getPosition())) {
          count++;
        }
      })

      this.markerNotInView = count;
    },
    zoomClicked: function(dir) {
      switch (dir) {
        case 'in':
          this.mapZoom++;
          break;
        case 'out':
          this.mapZoom--;
          break;
      }

      this.map.setZoom(this.mapZoom);
    },
    centerMap: function(pos, zoom) {
      this.map.setCenter(pos);
      this.map.setZoom(zoom ? zoom : 12);
    },
    //#endregion
  },
  mounted() {
    this.map = new google.maps.Map(this.$refs['customMapv2'], {
      center: this.mapCenter,
      zoom: this.mapZoom,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      maxZoom: 20,
      minZoom: 2,
      zoomControl: false,
      gestureHandling: 'coorperative',
      clickableIcons: false,
    });

    if (this.availableMapTypes.includes(this.mapType)) {
      this.currentMapType = this.mapType;
      this.map.setMapTypeId(this.currentMapType);
    } else {
      this.currentMapType = 'roadmap';
      this.map.setMapTypeId('roadmap');
    }

    this.map.addListener('click', this.mapClicked);
    this.map.addListener('drag', () => this.showContextMenu = false);
    this.map.addListener('zoom_changed', this.zoomChanged);
    this.map.addListener('bounds_changed', this.boundsChanged);

    this.mapSlotFloat = this.slotFloat;
    this.mapOpenMenu = this.openMenu;

    if (this.markers.length > 0) {
      this.markers.forEach((m, i) => {
        if (m['position']) {
          this.addMarker(m['position']);
        }

        if (m['geofence']) {
          this.addGeofenceByPosition(i, m['geofence']);
        }
      })
    }
   if (this.existingMarkers.length > 0) {
      this.existingMarkers.forEach((m, i) => {
        if (m['position']) {
          this.addFixedMarker(m['position']);
        }

        if (m['geofence']) {
          this.addFixedGeofenceByPosition(i, m['geofence']);
        }
      })
    }

    if (this.fixedMapMarkers.length > 1) {
      // this.centerMap(this.fixedMapMarkers[0]['marker'].getPosition(), 17);
      this.fitBounds();
    } else if (this.fixedMapMarkers.length == 1) {
      if (this.fixedMapMarkers[0]['geofence']) {
        this.fitBounds();
      } else {
        this.centerMap(this.fixedMapMarkers[0]['marker'].getPosition(), 17);
      }
    }

    if (this.mapMarkers.length > 1) {
      this.fitBounds();
    } else if (this.mapMarkers.length == 1) {
      if (this.mapMarkers[0]['geofence']) {
        this.fitBounds();
      } else {
        this.centerMap(this.mapMarkers[0]['marker'].getPosition(), 17);
      }
    }

    this.$emit('update:mapObject', this.map);
  },
  watch: {
   
    mapFullScreen: function() {
      this.showContextMenu = false;
    },
    openMenu: function(val) {
      this.mapOpenMenu = val;
    },
    // markers: function() {
    //   if (this.markers.length > 0) {
    //     this.markers.forEach((m, i) => {
    //       if (m['position']) {
    //         this.addMarker(m['position']);
    //       }

    //       if (m['geofence']) {
    //         this.addGeofenceByPosition(i, m['geofence']);
    //       }
    //     })
    //   }

    //   if (this.mapMarkers.length > 1) {
    //     this.fitBounds();
    //   } else if (this.mapMarkers.length == 1) {
    //     if (this.mapMarkers[0]['geofence']) {
    //       this.fitBounds();
    //     } else {
    //       this.centerMap(this.mapMarkers[0]['marker'].getPosition(), 17);
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.map-main {
  font-size: 12px;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;

  > .custom-map {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;

    > .map, > .context-menu-background {
      width: 100%;
      height: 100%;
    }

    > .context-menu-background {
      position: absolute;
      left: 0;
      top: 0;
      background-color: transparent;
      z-index: 15;
    }

    > .additional-buttons, > .zoom-buttons, > .info-buttons, > .map-type-button {
      min-width: 40px;
      max-width: 40px;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10;

      > .button {
        background-color: white;
        min-width: 40px;
        max-width: 40px;
        min-height: 40px;
        max-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        border-radius: 5px;
        cursor: pointer;
        user-select: none;
        box-shadow: 0 0 5px rgba(128, 128, 128, 0.75);
      }
    }

    > .zoom-buttons {
      display: flex;
      right: 60px;
      left: unset;
      min-width: unset;
      max-width: unset;
      min-height: 40px;
      max-height: 40px;

      > .button {
        margin-bottom: 0;
        margin-left: 10px;
      }
    }

    > .info-buttons {
      top: unset;
      bottom: 10px;
      min-width: unset;
      max-width: unset;
      min-height: 40px;
      max-height: 40px;

      > .button {
        margin-bottom: 0;
      }
    }

    > .map-type-button {
      bottom: 10px;
      left: 10px;
      right: unset;
      top: unset;

      > .button {
        margin: 0;
      }
    }

    > .message {
      position: absolute;
      padding: 5px;
      width: 100%;
      text-align: center;
      top: 0;
      z-index: 25;
      transition: 0.3s;

      > .message-close {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 0 10px;
        text-align: center;
        font-size: 1.1em;
        font-weight: bold;
      }
    }

    > .slot-float {
      width: 50%;
      max-height: 75%;
      position: absolute;
      top: 10px;
      left: 10px;
      border-radius: 5px;
      background-color: white;
      padding: 5px;
      z-index: 2;
      box-shadow: 0 0 5px rgba(128, 128, 128, 0.75);

      > img {
        position: sticky;
        left: 100%;
        top: 0px;
        cursor: pointer;
        z-index: 5;
      }
    }

    > .map-help-container {
      background-color: rgba(100,100,100,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 11;

      > .help-content {
        background-color: white;
        border-radius: 5px;
        padding: 5px;
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        max-width: 700px;
      }
    }
  }

  > .slot-div {
    background-color: white;
    padding: 5px;
    z-index: 2;
    width: 100%;
    position: relative;
    overflow: auto;
  }

  > .marker-context-menu {
    position: fixed;
    z-index: 20;
    background-color: white;
    border-radius: 5px;
    max-width: 150px;
    border: 1px solid gray;

    > .context-menu-item {
      border-bottom: 1px solid gray;
      padding: 5px;
      cursor: pointer;

      &:hover {
        background-color: rgba(100,100,100,0.3);
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.flex-row {
  display: flex;
  align-items: center;

  > :not(:first-child)  {
    margin-left: 5px;
  }
}

.carousel-content {
  height: 100%;
  width: 100%;
  display: flex;
  // flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;

  > .title {
    font-weight: bold;
    padding: 5px;
    width: 40%;
    max-height: 100%;
    overflow: auto;
    display: flex;
    text-align: center;
  }
  
  > .image-gif-container {
    height: 100%;
    width: 100%;

    > .image-gif {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}

.slidein-enter-active {
  opacity: 1;
  transform: translateY(0);
}

.slidein-leave-to, .slidein-enter {
  transform: translateY(-30px);
  opacity: 0;
}
</style>